import { render, staticRenderFns } from "./AdvertisementCreateModal.vue?vue&type=template&id=05137226&scoped=true"
import script from "./AdvertisementCreateModal.vue?vue&type=script&lang=js"
export * from "./AdvertisementCreateModal.vue?vue&type=script&lang=js"
import style0 from "./AdvertisementCreateModal.vue?vue&type=style&index=0&id=05137226&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05137226",
  null
  
)

export default component.exports